<template>
  <div class="person-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Configurações &raquo; Cartão digital</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="clientForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Cartão digital - {{ clientForm.name }}</p>

                    <div>
                      <a :href="digitalCardUrl + clientForm.professional_profile.slug" v-if="clientForm.professional_profile.enabled && clientForm.professional_profile.id != null" target="_blank" class="mr-3"><i class="far fa-link"></i></a>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="clientForm.professional_profile.enabled" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content">
                  <b-row>
                    <b-col cols="12" md="8">
                      <b-row>
                        <div class="logo-container">
                          <div id="personLogo" class="person-logo rounded" title="Marca" @click="$refs.fileInput.$el.childNodes[0].click()"></div>
                          <b-button class="delete-logo" size="sm" variant="danger" v-if="((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit)) && (currentLogo || logoFile || clientForm.logo)" @click="removeLogo"><i class="far fa-trash-alt"></i></b-button>
                          <label class="cj-label d-block">Selecionar marca</label>
                          <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="logoFile" accept=".jpg, .png" placeholder="" ref="fileInput" @input="logoChanged" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></b-form-file>
                        </div>
                        <b-col>
                          <label class="cj-label">Link para divulgação</label>
                          <validation-provider name="link para divulgação" :rules="{ required: true, slug: true }" v-slot="{ errors }">
                            <b-input-group :prepend="digitalCardUrl">
                              <b-form-input type="text" v-model="clientForm.professional_profile.slug" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            </b-input-group>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col>
                          <label class="cj-label">Cor primária</label>
                          <b-form-input type="color" v-model="clientForm.professional_profile.primary_color" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Cor secundária</label>
                          <b-form-input type="color" v-model="clientForm.professional_profile.secondary_color" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-row>
                            <div class="logo-container">
                              <div id="professionalProfileBackgroundImage" class="person-logo rounded" title="Imagem de fundo" @click="$refs.professionalProfileBackgroundImageInput.$el.childNodes[0].click()"></div>
                              <b-button class="delete-logo" size="sm" variant="danger" v-if="((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit)) && (currentProfessionalProfileBackgroundImage || professionalProfileBackgroundImageFile || clientForm.professional_profile.background_image)" @click="removeProfessionalProfileBackgroundImageLogo"><i class="far fa-trash-alt"></i></b-button>
                              <label class="cj-label d-block">Selecionar imagem<br>de fundo</label>
                              <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="professionalProfileBackgroundImageFile" accept=".jpg, .png" placeholder="" ref="professionalProfileBackgroundImageInput" @input="professionalProfileBackgroundImageChanged" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></b-form-file>
                            </div>
                            <b-col>
                              <label class="cj-label">Estilo da imagem de fundo</label>
                              <multiselect v-model="clientForm.professional_profile.background_image_style" :options="backgroundImageStyles" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></multiselect>
                            </b-col>
                            <b-col>
                              <label class="cj-label">Cor de fundo</label>
                              <b-form-input type="color" v-model="clientForm.professional_profile.background_color" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col>
                          <hr>
                          <b-row>
                            <b-col cols="8">
                              <multiselect v-model="fieldType" :options="fieldTypes" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))"></multiselect>
                            </b-col>
                            <b-col>
                              <b-button variant="primary" block class="mr-3" @click="openFieldModal" :disabled="!((clientForm.id == null && canAdd) || (clientForm.id != null && canEdit))">Adicionar</b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="mb-2">

                          <draggable v-model="clientForm.professional_profile.items" group="people" @start="drag=true" @end="drag=false" @change="profileFieldsChanged" tag="b-list-group">
                            <b-list-group-item v-for="(field, index) in clientForm.professional_profile.items" :key="field.id" class="d-flex justify-content-between align-items-center">
                              {{ (field.name !== null && field.name !== '') ? (field.name + ' - ') : '' }}{{ field.content }}
                              <b-button @click="editField(index)"><i class="far fa-edit"></i></b-button>
                            </b-list-group-item>
                          </draggable>
                        </b-col>
                      </b-row>

                    </b-col>
                    <b-col cols="12" md="4">
                      <b-row class="mb-3">
                        <b-col cols="6" offset="3" md="12" offset-md="0">
                          <label class="cj-label">Prévia</label>
                          <div id="professionalProfilePreview" :style='"background-color:" + clientForm.professional_profile.background_color + ";" + clientForm.professional_profile.background_image_style.css'>
                            <div class="p-3 d-flex flex-column align-items-center">
                              <div id="professionalProfileLogoPreview" class="mb-3"></div>
                              <div class="professional-name mb-1" :style='"color:" + clientForm.professional_profile.primary_color'>{{ clientForm.name }}</div>
                              <div class="mb-1" :style='"color:" + clientForm.professional_profile.secondary_color'></div>
                              <div class="mb-4" :style='"color:" + clientForm.professional_profile.secondary_color'></div>

                              <div v-for="(field, index) in clientForm.professional_profile.items" :key="field.id + '_' + index" class="custom-field mb-2 d-flex justify-content-between align-items-center" :class="field.name !== '' ? 'text-left' : ''">
                                <div>
                                  <div v-if="field.name !== ''" class="mb-1" :style='"color:" + clientForm.professional_profile.secondary_color'>{{field.name}}</div>
                                  <div class="custom-field-content" :style='"color:" + clientForm.professional_profile.primary_color'>{{field.content}}</div>
                                </div>
                                <div class="icon" v-if="field.show_icon && getProfileFieldIcon(field.type) !== ''" :style='"color:" + clientForm.professional_profile.primary_color'>
                                  <i :class="getProfileFieldIcon(field.type) + ' mr-2'"></i>
                                </div>
                              </div>
                            </div>
                            <div class="professional-card-footer p-2 mt-3" :style='"color:" + clientForm.professional_profile.primary_color + ";border-color:" + clientForm.professional_profile.secondary_color'>powered by Consultaja.com</div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(clientForm.id == null && canAdd) || (clientForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveProfessionalProfile" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

        </validation-observer>
      </div>
    </b-container>

    <b-modal id="field-modal" class="field-modal" size="lg" :modalClass="'field-modal'" @hidden="resetFieldModal">
      <template slot="modal-header">
        Adicionar novo campo
      </template>
      <template slot="default">
        <validation-observer ref="fieldForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Tipo do campo</label>
                <validation-provider name="tipo de campo" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.type" :options="fieldTypes" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de campo" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value != 'text'">
                <label class="cj-label">Mostrar ícone</label>
                <validation-provider name="mostrar ícone" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.show_icon" :options="showIconOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione uma agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Nome do campo</label>
                <b-form-input type="text" v-model="fieldForm.name"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col v-if="fieldForm.type.value == 'agenda'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.url" :options="agendas" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione uma agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'agenda'">
                <label class="cj-label">Texto da Agenda Online</label>
                <b-form-input type="text" v-model="fieldForm.content" autocomplete="off"></b-form-input>
              </b-col>

              <b-col v-if="fieldForm.type.value == 'email'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true, email: true }" v-slot="{ errors }">
                  <b-form-input type="email" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'address'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'instagram'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true, instagramUsername: true }" v-slot="{ errors }">
                  <b-input-group prepend="@">
                    <b-form-input type="text" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  </b-input-group>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>

              <b-col v-if="fieldForm.type.value == 'link'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="url" v-model="fieldForm.url" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'link'">
                <label class="cj-label">Texto do link</label>
                <b-form-input type="text" v-model="fieldForm.content" autocomplete="off"></b-form-input>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'phone'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="tel" v-model="fieldForm.content" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'whatsapp'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="tel" v-model="fieldForm.content" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'text'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-textarea v-model="fieldForm.content" rows="3" :class="{ 'error': errors.length > 0 }"></b-form-textarea>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>


          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('field-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="danger" v-if="fieldForm.id != null" @click="removeField(fieldForm.id)">Remover</b-button>
          <b-button variant="success" @click="addField">{{ (fieldForm.id == null?'Adicionar':'Editar') }}</b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        user: null,
        digitalCardUrl: process.env.VUE_APP_DIGITAL_CARD_URL,
        aolUrl: process.env.VUE_APP_AOL_URL,

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        currentLogo: null,
        logoFile: null,

        currentProfessionalProfileBackgroundImage: null,
        professionalProfileBackgroundImageFile: null,

        fieldType: null,
        fieldTypes: [
          { value: 'agenda', name: 'Agenda Online', icon: 'far fa-calendar-alt' },
          { value: 'email', name: 'E-mail', icon: 'far fa-envelope' },
          { value: 'address', name: 'Endereço', icon: 'far fa-map-marker-alt' },
          { value: 'instagram', name: 'Instagram', icon: 'fab fa-instagram' },
          { value: 'link', name: 'Link', icon: 'far fa-link' },
          { value: 'phone', name: 'Telefone', icon: 'far fa-phone fa-flip-horizontal' },
          { value: 'text', name: 'Texto livre', icon: '' },
          { value: 'whatsapp', name: 'Whatsapp', icon: 'fab fa-whatsapp' }
        ],
        backgroundImageStyles: [
          { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
          { value: 'contain', name: 'Conter', css: 'background-size:contain;' },
          { value: 'repeat', name: 'Repetir', css: 'background-repeat:repeat;' },
        ],

        agendas: [],

        fieldForm: {
          id: null,
          type: null,
          order: 0,
          name: '',
          content: '',
          url: '',
          show_icon: { value: true, name: 'Sim' }
        },

        showIconOptions: [
          { value: true, name: 'Sim' },
          { value: false, name: 'Não' }
        ],

        clientForm: {
          logo: null,
          delete_logo: false,
          name: '',
          professional_profile: {
            id: null,
            slug: null,
            primary_color: '#333333',
            secondary_color: '#999999',
            background_color: '#eeeeee',
            background_image: null,
            delete_background_image: false,
            background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
            enabled: false,
            items: []
          }
        }
      }
    },
    async mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_remove');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission('client-data', 'can_manage');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.user = JSON.parse(localStorage.getItem('user'));
      await this.api.getClient({is_professional_profile: 1}).then(res => {
        this.canPerformAction = true;
        if(this.leavingPage) {
          return;
        }

        let clientData = res.data;

        let professionalProfile = (clientData.client_professional_profile == null) ? {
          id: null,
          slug: null,
          primary_color: '#333333',
          secondary_color: '#999999',
          background_color: '#eeeeee',
          background_image: null,
          delete_background_image: false,
          background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
          enabled: false,
          items: []
        } : clientData.client_professional_profile;
        if(clientData.client_professional_profile != null) {
          professionalProfile.background_image_style = this.backgroundImageStyles.find(style => style.value === professionalProfile.background_image_style);
          if(professionalProfile.background_image_style === undefined) {
            professionalProfile.background_image_style = { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' };
          }
        }

        this.clientForm = {
          name: clientData.name,
          professional_profile: professionalProfile
        };
        this.currentLogo = clientData.logo;
        this.updateLogo();

        if(this.clientForm.professional_profile.slug === null || this.clientForm.professional_profile.slug === '') {
          this.clientForm.professional_profile.slug = this.slugify(this.clientForm.name);
        }
        this.currentProfessionalProfileBackgroundImage = professionalProfile.background_image;
        this.updateProfessionalProfileBackgroundImage();

        if(typeof clientData.agendas != 'undefined') {
          clientData.agendas.forEach(agenda => {
            if(agenda.online_scheduling) {
              this.agendas.push({value: this.aolUrl + agenda.id, name: agenda.name});
            }
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Person', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.goBack();

        this.$swal('Ops...', 'Não conseguimos carregar os dados do consultório! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Person', err.response);
      });
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      async saveProfessionalProfile() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.clientForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if(this.canManage) {
          let professionalProfileData = {
            id: this.clientForm.id,
            logo: this.clientForm.logo,
            delete_logo: this.clientForm.delete_logo,
            professional_profile: {
              id: this.clientForm.professional_profile.id,
              slug: this.clientForm.professional_profile.slug,
              primary_color: this.clientForm.professional_profile.primary_color,
              secondary_color: this.clientForm.professional_profile.secondary_color,
              background_color: this.clientForm.professional_profile.background_color,
              background_image: this.clientForm.professional_profile.background_image,
              delete_background_image: this.clientForm.professional_profile.delete_background_image,
              background_image_style: this.clientForm.professional_profile.background_image_style.value,
              enabled: this.clientForm.professional_profile.enabled,
              items: this.clientForm.professional_profile.items
            }
          };

          this.eventBus.$emit('IS_LOADING', true);
          if (this.clientForm.professional_profile.id == null) {
            this.api.storeClientProfessionalProfile(professionalProfileData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 201) {
                this.$swal('Uhull \\o/', 'O cartão digital foi cadastrado com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Store Person', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              this.$swal('Ops...', message, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Store Person', err.response);
            });
          } else {
            this.api.updateClientProfessionalProfile(this.clientForm.professional_profile.id, professionalProfileData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 200) {
                this.$swal('Uhull \\o/', 'O cartão digital foi atualizado com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao atualizar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Update Person', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              this.$swal('Ops...', message, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Update Person', err.response);
            });
          }
        }
      },

      logoChanged() {
        this.clientForm.logo = null;
        if (this.logoFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.clientForm.logo = event.target.result;
            scope.updateLogo();
          };
          reader.readAsDataURL(this.logoFile);
        }
        else {
          this.updateLogo();
        }
      },

      professionalProfileBackgroundImageChanged() {
        this.clientForm.professional_profile.background_image = null;
        if (this.professionalProfileBackgroundImageFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.clientForm.professional_profile.background_image = event.target.result;
            scope.updateProfessionalProfileBackgroundImage();
          };
          reader.readAsDataURL(this.professionalProfileBackgroundImageFile);
        }
        else {
          this.updateProfessionalProfileBackgroundImage();
        }
      },

      removeLogo() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover marca',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.clientForm.logo = null;
            this.currentLogo = null;
            this.logoFile = null;
            this.clientForm.delete_logo = true;
            this.updateLogo();
          }
        });
      },

      removeProfessionalProfileBackgroundImageLogo() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover foto',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.clientForm.professional_profile.background_image = null;
            this.currentProfessionalProfileBackgroundImage = null;
            this.professionalProfileBackgroundImageFile = null;
            this.clientForm.professional_profile.delete_background_image = true;
            this.updateProfessionalProfileBackgroundImage();
          }
        });
      },

      updateLogo() {
        let logo = '', hasLogo = true;
        if(this.clientForm.logo != null) {
          logo = this.clientForm.logo;
        } else if(this.currentLogo != null) {
          logo = this.currentLogo;
        } else {
          hasLogo = false;
          logo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
        }
        if(document.getElementById('personLogo')) {
          document.getElementById('personLogo').style.backgroundImage = 'url("' + logo + '")';
        }
        if(document.getElementById('personLogoPreview')) {
          document.getElementById('personLogoPreview').style.backgroundImage = 'url("' + logo + '")';
        }
        if(document.getElementById('professionalProfileLogoPreview')) {
          logo = hasLogo ? logo : require('@/assets/images/digital-card-avatar.jpg');
          document.getElementById('professionalProfileLogoPreview').style.backgroundImage = 'url("' + logo + '")';
        }
      },

      updateProfessionalProfileBackgroundImage() {
        let logo = '';
        if(this.clientForm.professional_profile.background_image != null) {
          logo = this.clientForm.professional_profile.background_image;
        } else if(this.currentProfessionalProfileBackgroundImage != null) {
          logo = this.currentProfessionalProfileBackgroundImage;
        } else {
          logo = '';
        }
        if(document.getElementById('professionalProfileBackgroundImage')) {
          document.getElementById('professionalProfileBackgroundImage').style.backgroundImage = 'url("' + logo + '")';
        }
        if(document.getElementById('professionalProfilePreview')) {
          document.getElementById('professionalProfilePreview').style.backgroundImage = 'url("' + logo + '")';
        }
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      goBack() {
        this.$router.push({path: '/configuracoes/configuracoes-gerais'}).catch(() => {});
      },

      getProfileFieldIcon(fieldType) {
        return this.fieldTypes.find(type => type.value === fieldType).icon;
      },

      slugify(text) {
        return text
            .toString()                     // Cast to string
            .toLowerCase()                  // Convert the string to lowercase letters
            .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
            .trim()                         // Remove whitespace from both sides of a string
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w-]+/g, '')       // Remove all non-word chars
            .replace(/--+/g, '-');        // Replace multiple - with single -
      },

      profileFieldsChanged() {
        for(let index = 0; index < this.clientForm.professional_profile.items.length; index++) {
          this.clientForm.professional_profile.items[index].order = index;
        }
      },

      async openFieldModal() {
        if(!this.canPerformAction || this.fieldType == null)
          return false;

        this.canPerformAction = false;

        let currentOrder = this.clientForm.professional_profile.items.length;
        if(currentOrder === 20) {
          this.canPerformAction = true;
          this.$swal('Desculpe', 'Não é possível adicionar mais campos!', 'error');
          return false;
        }
        if (this.fieldType.value != 'link' && this.fieldType.value != 'text') {
          this.fieldForm.name = this.fieldType.name;
        }

        this.canPerformAction = true;
        this.fieldForm.type = this.fieldType;
        this.fieldForm.order = currentOrder;
        this.$bvModal.show('field-modal');
      },
      resetFieldModal() {
        this.fieldForm = {
          id: null,
          type: null,
          order: 0,
          name: '',
          content: '',
          url: '',
          show_icon: { value: true, name: 'Sim' }
        };
      },
      async addField() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.fieldForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let url = this.fieldForm.url;
        if(this.fieldForm.type.value == 'agenda') {
          url = url.value;
        }

        let fieldData = {
          id: this.fieldForm.id,
          type: this.fieldForm.type.value,
          name: this.fieldForm.name,
          content: this.fieldForm.content,
          url: url,
          order: this.fieldForm.order,
          show_icon: this.fieldForm.show_icon.value
        };

        if(fieldData.id == null) {
          fieldData.id = this.helpers.uuidv4();

          this.clientForm.professional_profile.items.push(fieldData);
        } else {
          this.clientForm.professional_profile.items = this.clientForm.professional_profile.items.map(field => {
            if(field.id == fieldData.id)
              field = fieldData;

            return field;
          });
        }

        this.clientForm.professional_profile.items.sort((a, b) => (a.order > b.order)?1:-1);

        this.$bvModal.hide('field-modal');
        this.canPerformAction = true;
      },
      async editField(index) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        let field = this.clientForm.professional_profile.items[index];

        this.fieldForm = {
          id: field.id,
          type: this.fieldTypes.find(type => type.value === field.type),
          order: field.order,
          name: field.name,
          content: field.content,
          url: field.url,
          show_icon: this.showIconOptions.find(showIcon => showIcon.value === field.show_icon),
        };
        if(field.type == 'agenda') {
          this.fieldForm.url = this.agendas.find(agenda => agenda.value === field.url);
        }

        this.$bvModal.show('field-modal');
        this.canPerformAction = true;
      },
      async removeField(fieldId) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.clientForm.professional_profile.items = this.clientForm.professional_profile.items.filter(field => {
          return field.id != fieldId
        });

        this.$bvModal.hide('field-modal');
        this.canPerformAction = true;
      },
    },

    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .person-form {
    padding: 20px 0;

    .logo-container {
      position: relative;
      text-align: center;

      .person-logo {
        cursor: pointer;
        margin-left: 15px;
        margin-right: 15px;
        width: 70px;
        height: 70px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;

        &#personLogoPreview {
          cursor: default;
        }
      }

      .delete-logo {
        position: absolute;
        top: 0;
        right: 15px;
        padding: 0.25rem 0.45rem;
        font-size: 0.8rem;
      }
    }
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }
  .input-group-prepend {
    height: 35px;

    .input-group-text {
      font-size: 15px;
    }
  }

  .input-group-append {
    height: 35px;
  }

  #professionalProfilePreview {
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    font-size: 13px;

    #professionalProfileLogoPreview {
      width: 100px;
      height: 100px;
      background: #f0f0f0 no-repeat 50%;
      background-size: cover;
    }

    .professional-name {
      font-size: 14px;
    }

    .custom-field {
      background: #fffffff2;
      border-radius: 14px;
      padding: 14px;
      width: 100%;

      .custom-field-content {
        font-size: 14px;
      }

      .icon {
        font-size: 15px;
      }
    }

    .professional-card-footer {
      border-top: 1px solid #ccc;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
